import React from 'react';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import Link from '../Global/Link';
import Richtext from '../Richtext/Richtext';
import ImageHandler from '../../utils/ImageHandler';

// ====

// ====

const Hero = (props) => {
  const {
    title,
    copy,
    image,
    align,
    date,
    author,
    color,
    backgroundColor,
    id,
    items,
    screen,
  } = props;

  // ====

  return (
    <>
      <article
        id={id}
        className={`w-100 brand-screen brand-screen-natural ${screen}`}
        style={{
          backgroundColor: `${backgroundColor}`,
          backgroundImage: `url(${ImageHandler(image.filename, '1920x1080')})`,
        }}
      >
        <div className="d-flex w-100 h-100 justify-content-center align-items-center">
          <div className="container pt-5 pb-5">
            <div className="row justify-content-center">
              <div className={`col-12 text-${align} text-${color}`}>
                {title && <h1 className="brand-font">{title}</h1>}
                {author && <p>Posted by: {author}</p>}
                {date && (
                  <p>
                    Posted on: <Moment format="Do MMMM, YYYY" date={date} />
                  </p>
                )}
                {copy && <Richtext content={copy} />}
              </div>
            </div>
            {items && (
              <div className="row justify-content-center">
                {items.map((node) => {
                  return (
                    <div className="brand-col col-12 col-lg-4" key={node._uid}>
                      <div className="card h-100">
                        <img
                          src={node.image.filename}
                          className="card-img-top"
                          alt={node.title}
                        />
                        <div className="card-body">
                          <h3 className="card-title">{node.title}</h3>
                          <p className="card-text">{node.description}</p>
                        </div>
                        <div className="card-footer text-right">
                          <Link
                            to={`/${node.link.cached_url}`}
                            className="stretched-link"
                          >
                            Link
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </article>
    </>
  );
};

export default Hero;

// ====

Hero.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  copy: PropTypes.arrayOf,
  align: PropTypes.string,
  author: PropTypes.string,
  color: PropTypes.string,
  items: PropTypes.arrayOf,
  backgroundColor: PropTypes.string,
  screen: PropTypes.string,
  image: PropTypes.shape({
    filename: PropTypes.string,
    alt: PropTypes.string,
  }),
};

Hero.defaultProps = {
  id: null,
  title: null,
  copy: null,
  author: null,
  align: 'center',
  color: 'white',
  items: null,
  backgroundColor: '#cccccc',
  screen: null,
  image: {
    filename: null,
    alt: null,
  },
};
